import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import deleteFilter from '../../services/delete-filter/index.tsx';
import {
	type Action,
	DELETE_FILTER,
	deleteFilterFailed,
	filterDeleted,
} from '../../state/actions.tsx';
import { getFilter, getOnFilterDeleted, getOnFilterDeleteFailed } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

const deleteEpic = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
	action$.ofType(DELETE_FILTER).mergeMap(({ onComplete }) => {
		const state = store.getState();
		const filter = getFilter(state);

		return Observable.fromPromise(deleteFilter(filter.id))
			.mergeMap(() => {
				getOnFilterDeleted(state)(filter);
				onComplete?.();
				return Observable.of(filterDeleted());
			})
			.catch((error: FetchError) => {
				log.safeErrorWithoutCustomerData(
					'directories.filters-v2.delete-modal.ops.delete-filter',
					error.message,
					error,
				);
				getOnFilterDeleteFailed(state)(filter);
				return Observable.of(deleteFilterFailed());
			});
	});

export default deleteEpic;
